import { GetTrendsParams } from "../../app/api/trends";
import { keysToRemoveForGraphAnalysis } from "../../constants/constants";
import { removeKeysFromObject } from "../commonUtils";

export const getTrendFiltersFromSession = (): GetTrendsParams | null => {
  try {
    const sessionStorageData = sessionStorage.getItem("trends");
    if (!sessionStorageData) return null;

    const trendFilters: GetTrendsParams = JSON.parse(sessionStorageData);

    return trendFilters;
  } catch (error) {
    console.error("Error parsing trend filters from sessionStorage", error);
    return null;
  }
};

export const getTrendFiltersForGraphs = () => {
  const trendFilters = getTrendFiltersFromSession();
  if (!trendFilters) return null;
  removeKeysFromObject(trendFilters, keysToRemoveForGraphAnalysis);
  return trendFilters;
};
